<template>
    <div class="scheduled-clients-button"
        v-if="!showPreditivaCampaign && !showImplantacaoCampaign && !showBillingCampaign">
        <button class="btn btn-info scheduled-btn" @click="showScheduledClients">
            <i class="fa-solid fa-calendar-day" style="font-size: 15px;"></i>
            Lembrete Preditivo

            <!-- Badge mostra sempre o total de agendamentos, com cor baseada na urgência -->
            <span v-if="clients.length > 0" :class="{
                'alert-badge-danger pulse': overdueCallsCount > 0,
                'alert-badge-warning pulse': overdueCallsCount === 0 && upcomingCallsCount > 0,
                'notification-badge': overdueCallsCount === 0 && upcomingCallsCount === 0
            }">
                {{ clients.length }}
            </span>
        </button>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import { mapGetters } from "vuex";

const parsedTelefone = process.env.MIX_TELEFONE === "true";
const connection = parsedTelefone ? io.connect(`${location.protocol}//${location.hostname}:3002/`) : { on: function () { }, emit: function () { } };

export default {
    name: "ScheduledClients",
    data() {
        return {
            clients: [],
            notifiedClients: [],
            checkInterval: null,
            upcomingCallsCount: 0,
            overdueCallsCount: 0,
            isModalOpen: false,
        };
    },
    computed: {
        ...mapGetters({
            showPreditivaCampaign: "getShowPreditivaCampaign",
            showImplantacaoCampaign: "getShowImplantacaoCampaign",
            showBillingCampaign: "getShowBillingCampaign",
        }),
    },
    methods: {
        async checkClients() {
            try {
                const { data } = await axios.get("/getScheduledCalls");
                const clients = Array.isArray(data) ? data : (data ? [data] : []);
                this.clients = clients.filter(client =>
                    client.scheduled_to === null || Number(client.scheduled_to) === Number(user.getId())
                );
                this.checkUpcomingCalls();
            } catch (error) {
                this.clients = [];
            }
        },

        checkUpcomingCalls() {
            const now = moment();
            const upcomingCalls = [];
            const overdueCalls = [];

            this.clients.forEach(client => {
                const scheduleTime = moment(client.schedule_date);
                const diffInMinutes = scheduleTime.diff(now, 'minutes');

                if (diffInMinutes < 0) {
                    overdueCalls.push(client);
                } else if (diffInMinutes >= 0 && diffInMinutes <= 5) {
                    upcomingCalls.push(client);
                }
            });

            this.upcomingCallsCount = upcomingCalls.length;
            this.overdueCallsCount = overdueCalls.length;

            const allUrgentCalls = [...overdueCalls, ...upcomingCalls];
            const groupedByTime = allUrgentCalls.reduce((acc, client) => {
                const timeKey = moment(client.schedule_date).format('YYYY-MM-DD HH:mm');
                if (!acc[timeKey]) {
                    acc[timeKey] = [];
                }
                acc[timeKey].push(client);
                return acc;
            }, {});

            const groupKeys = Object.keys(groupedByTime).sort().join('|');
            
            // Só notifica se o modal NÃO estiver aberto E se ainda não foi notificado
            if (!this.isModalOpen && !this.notifiedClients.includes(groupKeys) && allUrgentCalls.length > 0) {
                this.notifyUrgentCalls(overdueCalls, upcomingCalls);
                this.notifiedClients.push(groupKeys);
            }
        },

        formatDelayTime(minutes) {
            const absMinutes = Math.abs(minutes);

            if (absMinutes < 60) {
                return `há ${absMinutes} min`;
            } else if (absMinutes < 1440) {
                const hours = Math.floor(absMinutes / 60);
                const remainingMinutes = absMinutes % 60;
                if (remainingMinutes === 0) {
                    return `há ${hours}h`;
                }
                return `há ${hours}h ${remainingMinutes}min`;
            } else {
                const days = Math.floor(absMinutes / 1440);
                const remainingHours = Math.floor((absMinutes % 1440) / 60);
                if (remainingHours === 0) {
                    return `há ${days} ${days === 1 ? 'dia' : 'dias'}`;
                }
                return `há ${days} ${days === 1 ? 'dia' : 'dias'} e ${remainingHours}h`;
            }
        },

        notifyUrgentCalls(overdueCalls, upcomingCalls) {
            const totalCount = overdueCalls.length + upcomingCalls.length;

            // Notificação do navegador
            if ("Notification" in window && Notification.permission === "granted") {
                let notificationText = '';

                if (overdueCalls.length > 0 && upcomingCalls.length > 0) {

                    const overdueText = overdueCalls.length === 1
                        ? `1 ligação atrasada`
                        : `${overdueCalls.length} ligações atrasadas`;

                    const upcomingText = upcomingCalls.length === 1
                        ? `1 ligação próxima`
                        : `${upcomingCalls.length} ligações próximas`;

                    notificationText = `${overdueText} e ${upcomingText}`;

                } else if (overdueCalls.length > 0) {

                    notificationText = overdueCalls.length === 1
                        ? `1 ligação atrasada`
                        : `${overdueCalls.length} ligações atrasadas`;

                } else {

                    notificationText = upcomingCalls.length === 1
                        ? `1 ligação próxima`
                        : `${upcomingCalls.length} ligações próximas`;
                }

                new Notification("Ligações Agendadas", {
                    body: notificationText,
                    icon: "/imgs/advance_telecom.png",
                    tag: `urgent-calls`,
                });
            }

            // Abre o modal apenas se não estiver aberto
            if (!this.isModalOpen) {
                this.showScheduledClients();
            }
        },

        // playNotificationSound() {
        //     try {
        //         const audio = new Audio('/sounds/notification.mp3');
        //         audio.volume = 0.5;
        //         this.audio.play();
        //     } catch (e) {
        //         console.log('Erro ao tocar som');
        //     }
        // },

        async showScheduledClients() {
            // Marcar que o modal está sendo aberto manualmente
            this.isModalOpen = true;
            
            await this.checkClients();
            const check = this.clients;

            if (check) {
                check.sort((a, b) => moment(a.schedule_date).unix() - moment(b.schedule_date).unix());
            }

            const now = moment();
            const upcomingSchedules = (check || [])
                .filter((client) => {
                    return (
                        client.scheduled_to === null || Number(client.scheduled_to) === Number(user.getId())
                    );
                })
                .map((client) => {
                    const scheduleTime = moment(client.schedule_date);
                    const diffInMinutes = scheduleTime.diff(now, 'minutes');

                    let status = 'normal';
                    if (diffInMinutes < 0) {
                        status = 'overdue';
                    } else if (diffInMinutes >= 0 && diffInMinutes <= 5) {
                        status = 'upcoming';
                    }

                    return {
                        id: client.id,
                        clientName: client.client_name,
                        phone: client.client_phone,
                        scheduleDate: client.schedule_date,
                        time: scheduleTime.format("DD/MM/YYYY HH:mm"),
                        consultant: client.scheduled_name?.trim() || "Livre",
                        status: status,
                        minutesRemaining: diffInMinutes,
                    };
                });

            // Separar por categorias
            const overdueSchedules = upcomingSchedules.filter(s => s.status === 'overdue');
            const upcomingSchedulesFiltered = upcomingSchedules.filter(s => s.status === 'upcoming');
            const normalSchedules = upcomingSchedules.filter(s => s.status === 'normal');

            // Paginação
            const itemsPerPage = 5;
            let currentPage = 1;
            const totalPages = Math.ceil(upcomingSchedules.length / itemsPerPage);

            const renderPage = (page) => {
                const startIndex = (page - 1) * itemsPerPage;
                const endIndex = startIndex + itemsPerPage;
                const pageItems = upcomingSchedules.slice(startIndex, endIndex);

                let scheduleListHTML = `<div style="display:flex; flex-direction:column; gap:10px; padding:8px;">`;

                pageItems.forEach((schedule) => {
                    let statusStyle = '';
                    let badgeColor = '#28a745';

                    if (schedule.status === 'overdue') {
                        statusStyle = 'border-left: 4px solid #dc3545; background: #fff5f5;';
                        badgeColor = '#dc3545';
                    } else if (schedule.status === 'upcoming') {
                        statusStyle = 'border-left: 4px solid #ffc107; background: #fffbf0;';
                        badgeColor = '#ffc107';
                    } else {
                        statusStyle = 'border-left: 4px solid #28a745; background: #f0fff4;';
                        badgeColor = '#28a745';
                    }

                    scheduleListHTML += `
<div style="
    display:flex;
    justify-content:space-between;
    align-items:center;
    background:#fff;
    padding:12px 14px;
    border-radius:10px;
    border:1px solid #e0e0e0;
    box-shadow:0 2px 4px rgba(0,0,0,0.05);
    transition: all 0.2s ease;
    ${statusStyle}
" 
onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 10px rgba(0,0,0,0.12)';" 
onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.05)';">

    <div style="display:flex; flex-direction:column; gap:4px;">
        <div style="display: flex; align-items: center;">
            <strong style="color:#1a6fa5; font-size:15px;">${schedule.clientName}</strong>
        </div>
        <span style="color:#555; font-size:13px; display:flex; align-items:center; gap:5px;">
            <i class="fas fa-user" style="color:#16a085;"></i> ${schedule.consultant}
        </span>
        <span style="color:#555; font-size:13px; display:flex; align-items:center; gap:5px;">
            <i class="fas fa-phone-alt" style="color:#2980b9;"></i> ${schedule.phone}
        </span>

        ${schedule.status === 'overdue'
                            ? `
            <div style="
                color:#c0392b;
                font-size:12px;
                font-weight:bold;
                margin-top:-2px;
                margin-bottom:6px;
            ">
                Atrasada ${this.formatDelayTime(schedule.minutesRemaining)}
            </div>
        `
                            : ''
                        }
    </div>

    <div style="display:flex; flex-direction:column; align-items:flex-end; gap:6px;">
        <span style="
            background:${badgeColor};
            color:white;
            font-weight:bold;
            font-size:13px;
            padding:3px 10px;
            border-radius:12px;
            display:flex;
            align-items:center;
            gap:4px;
        ">
            <i class="fas fa-clock"></i> ${schedule.time}
        </span>

        <button 
            data-phone="${schedule.phone}"
            class="btn-call-schedule"
            style="
                background:#27ae60;
                color:white;
                border:none;
                padding:6px 14px;
                border-radius:10px !important;
                cursor:pointer;
                font-size:11px;
                font-weight:600;
                display:flex;
                align-items:center;
                gap:6px;
                transition: background 0.2s;
            "
            onmouseover="this.style.background='#219150';"
            onmouseout="this.style.background='#27ae60';"
        >
            <i class="fas fa-phone-alt"></i> Ligar
        </button>
    </div>
</div>
`;
                });

                scheduleListHTML += "</div>";
                return scheduleListHTML;
            };

            const renderPagination = (page) => {
                if (totalPages <= 1) return '';

                return `
                    <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        margin-top: 12px;
                        padding-top: 12px;
                        border-top: 1px solid #e0e0e0;
                    ">
                        <button 
                            class="btn-pagination-prev"
                            style="
                                background: ${page === 1 ? '#e0e0e0' : '#007bff'};
                                color: ${page === 1 ? '#999' : 'white'};
                                border: none;
                                padding: 10px 15px;
                                border-radius: 6px !important;
                                cursor: ${page === 1 ? 'not-allowed' : 'pointer'};
                                font-size: 13px;
                                font-weight: 600;
                                transition: all 0.2s;
                            "
                            ${page === 1 ? 'disabled' : ''}
                        >
                            <i class="fas fa-chevron-left"></i> Anterior
                        </button>

                        <span style="
                            font-size: 13px;
                            color: #6c757d;
                            font-weight: 600;
                            padding: 0 12px;
                        ">
                            Página ${page} de ${totalPages}
                        </span>

                        <button 
                            class="btn-pagination-next"
                            style="
                                background: ${page === totalPages ? '#e0e0e0' : '#007bff'};
                                color: ${page === totalPages ? '#999' : 'white'};
                                border: none;
                                padding: 10px 15px;
                                border-radius: 6px !important;
                                cursor: ${page === totalPages ? 'not-allowed' : 'pointer'};
                                font-size: 14px;
                                font-weight: 600;
                                transition: all 0.2s;
                            "
                            ${page === totalPages ? 'disabled' : ''}
                        >
                            Próximo <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>
                `;
            };

            // Resumo de estatísticas
            const statsHTML = `
                <div style="
                    display: flex;
                    justify-content: space-around;
                    gap: 12px;
                    margin-bottom: 16px;
                    padding: 12px;
                    background: #f8f9fa;
                    border-radius: 10px;
                ">
                    <div style="text-align: center; flex: 1;">
                        <div style="
                            font-size: 24px;
                            font-weight: bold;
                            color: #dc3545;
                        ">
                            ${overdueSchedules.length}
                        </div>
                        <div style="
                            font-size: 12px;
                            color: #6c757d;
                            margin-top: 4px;
                        ">
                            Atrasadas
                        </div>
                    </div>
                    <div style="text-align: center; flex: 1; border-left: 1px solid #dee2e6; border-right: 1px solid #dee2e6;">
                        <div style="
                            font-size: 24px;
                            font-weight: bold;
                            color: #ffc107;
                        ">
                            ${upcomingSchedulesFiltered.length}
                        </div>
                        <div style="
                            font-size: 12px;
                            color: #6c757d;
                            margin-top: 4px;
                        ">
                            Próximas (5 min)
                        </div>
                    </div>
                    <div style="text-align: center; flex: 1;">
                        <div style="
                            font-size: 24px;
                            font-weight: bold;
                            color: #28a745;
                        ">
                            ${normalSchedules.length}
                        </div>
                        <div style="
                            font-size: 12px;
                            color: #6c757d;
                            margin-top: 4px;
                        ">
                            Agendadas
                        </div>
                    </div>
                </div>
            `;

            // Legenda
            const legendHTML = `
                <div style="
                    display: flex;
                    justify-content: center;
                    gap: 20px;
                    margin-bottom: 16px;
                    padding: 10px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #e0e0e0;
                ">
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <div style="
                            width: 12px;
                            height: 12px;
                            background: #dc3545;
                            border-radius: 3px;
                        "></div>
                        <span style="font-size: 12px; color: #6c757d;">Atrasada</span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <div style="
                            width: 12px;
                            height: 12px;
                            background: #ffc107;
                            border-radius: 3px;
                        "></div>
                        <span style="font-size: 12px; color: #6c757d;">Próxima (0-5 min)</span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <div style="
                            width: 12px;
                            height: 12px;
                            background: #28a745;
                            border-radius: 3px;
                        "></div>
                        <span style="font-size: 12px; color: #6c757d;">Agendada (+5 min)</span>
                    </div>
                </div>
            `;

            Swal.fire({
                width: "680px",
                html: `
    <div style="font-family:'Arial', sans-serif; text-align:center;">
        <div style="
            display:flex;
            justify-content:center;
            align-items:center;
            background-color:${upcomingSchedules.length > 0 ? '#16a085' : '#e74c3c'};
            border-radius:50%;
            width:60px;
            height:60px;
            margin:0 auto;
            color:#fff;
        ">
            <i class="fas ${upcomingSchedules.length > 0 ? 'fa-calendar-check' : 'fa-calendar-xmark'}" style="font-size:28px;"></i>
        </div>

        <h3 style="color:#2c3e50; margin:15px 0 16px; font-size:17px; font-weight:bold;">
            ${upcomingSchedules.length > 0 ? "Clientes Agendados!" : "Sem Clientes Agendados"}
        </h3>

        ${upcomingSchedules.length > 0 ? statsHTML : ''}
        ${upcomingSchedules.length > 0 ? legendHTML : ''}

        <div id="schedules-container" style="max-height:380px; overflow-y:auto; padding-right:6px; text-align:left; margin-bottom: 12px;">
            ${upcomingSchedules.length > 0 ? renderPage(currentPage) : "<p style='color:#555; font-size:14px; text-align:center;'>Sem clientes agendados</p>"}
        </div>

        ${upcomingSchedules.length > 0 ? `
            <p style="color:#555; font-size:14px; text-align:center; margin: 0;">
                Total: <strong style="color:#dc3545;">${upcomingSchedules.length}</strong> ${upcomingSchedules.length === 1 ? 'cliente agendado' : 'clientes agendados'}
            </p>
            <div id="pagination-container">
                ${renderPagination(currentPage)}
            </div>
        ` : ""}
    </div>
    `,
                showCloseButton: true,
                showConfirmButton: false,
                background: "#ecf0f1",
                customClass: { popup: "animated fadeInDown" },

                onOpen: (popup) => {
                    const container = popup.querySelector('#schedules-container');
                    const paginationContainer = popup.querySelector('#pagination-container');

                    const updatePage = (newPage) => {
                        currentPage = newPage;
                        container.innerHTML = renderPage(currentPage);
                        if (paginationContainer) {
                            paginationContainer.innerHTML = renderPagination(currentPage);
                        }
                        container.scrollTop = 0;
                    };

                    popup.addEventListener("click", (e) => {
                        // Botão ligar
                        const btnCall = e.target.closest(".btn-call-schedule");
                        if (btnCall) {
                            const phone = btnCall.getAttribute("data-phone") || btnCall.dataset.phone;
                            if (!phone) return;

                            const client = this.clients.find(c => c.client_phone === phone);
                            if (client) {
                                sessionStorage.setItem("campaignClient", JSON.stringify(client));
                            }

                            this.call_client(phone);
                            Swal.close();
                            return;
                        }

                        // Botão anterior
                        const btnPrev = e.target.closest(".btn-pagination-prev");
                        if (btnPrev && !btnPrev.disabled) {
                            updatePage(currentPage - 1);
                            return;
                        }

                        // Botão próximo
                        const btnNext = e.target.closest(".btn-pagination-next");
                        if (btnNext && !btnNext.disabled) {
                            updatePage(currentPage + 1);
                            return;
                        }
                    });
                },
                onClose: () => {
                    this.isModalOpen = false;
                },
            });
        },

        call_client(phone) {
            if (phone) {
                const formattedPhone = this.formatPhoneToCall(phone);
                connection.emit("OriginateTabDial", {
                    calltype: "outgoing",
                    extension: user.getExtension(),
                    phone: formattedPhone,
                });
            }
        },

        formatPhoneToCall(phone) {
            let newPhone = phone.replace(/\D/g, "");

            if (newPhone.slice(0, 1) == "0") {
                newPhone = newPhone.slice(1);
            }
            if (newPhone.slice(0, 2) == "55") {
                newPhone = `0${newPhone.slice(2)}`;
            }

            return newPhone;
        },

        requestNotificationPermission() {
            if ("Notification" in window && Notification.permission === "default") {
                Notification.requestPermission();
            }
        },
    },

    mounted() {
        this.checkClients();
        this.requestNotificationPermission();

        this.checkInterval = setInterval(() => {
            this.checkClients();
        }, 30000);
    },

    beforeDestroy() {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
        }
    },
};
</script>

<style scoped>
.notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #28a745;
    color: white;
    font-size: 14px;
    font-weight: bold;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.alert-badge-warning {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #ffc107;
    color: white;
    font-size: 14px;
    font-weight: bold;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.alert-badge-danger {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #dc3545;
    color: white;
    font-size: 14px;
    font-weight: bold;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pulse {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(231, 76, 60, 0.7);
    }

    50% {
        transform: scale(1.1);
        box-shadow: 0 0 0 10px rgba(231, 76, 60, 0);
    }

    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(231, 76, 60, 0);
    }
}

.alert-badge-warning.pulse {
    animation: pulse-warning 1.5s infinite;
}

@keyframes pulse-warning {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
    }

    50% {
        transform: scale(1.1);
        box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
    }

    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    }
}

.scheduled-clients-button {
    position: absolute;
    right: 0;
    top: 0;
    margin: 20px;
}

.scheduled-btn {
    background-color: #007bff;
    color: white;
    border-radius: 20px !important;
    margin: 0;
    padding: 10px 30px;
    font-weight: bold;
    font-size: 14px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    transition: background-color 0.3s, transform 0.2s;
    border: none;
    position: relative;
}

.scheduled-btn:hover {
    background-color: #0056b3;
    transform: scale(1.05);
}

:global(.minimal-notification-popup) {
    border-radius: 16px !important;
}

:global(.minimal-close-btn) {
    font-size: 28px !important;
    color: #95a5a6 !important;
}

:global(.minimal-close-btn:hover) {
    color: #7f8c8d !important;
}
</style>